import type { ActionResult } from '@mentora/app-shared/i18n/action-result'

// The browser's way to the shared API (apps/api), through the web app's own
// `/api/*` rewrite: same origin, so the session cookie goes with it. The
// endpoints answer in the same `ActionResult` shape a server action returns,
// so callers handle both alike. A request that never gets an answer becomes
// `networkKey`, never a thrown error.

const TIMEOUT_MS = 30_000

export async function callApi<T>(
  path: string,
  init: { method: 'GET' } | { method: 'POST', body: unknown },
  networkKey: string,
): Promise<ActionResult<T>> {
  try {
    const res = await fetch(path, {
      method: init.method,
      credentials: 'same-origin',
      signal: AbortSignal.timeout(TIMEOUT_MS),
      ...(init.method === 'POST' ? { headers: { 'content-type': 'application/json' }, body: JSON.stringify(init.body) } : {}),
    })
    const body = await res.json().catch(() => null) as ActionResult<T> | null
    if (body && typeof body === 'object' && 'ok' in body)
      return body
    console.error('[api] unexpected response', { path, status: res.status })
    return { ok: false, errorKey: networkKey }
  }
  catch (err) {
    console.error('[api] request failed', { path, err })
    return { ok: false, errorKey: networkKey }
  }
}
